<template>
        <div class="sm:mt-10 text-brand-teal max-w-[85rem] mx-auto px-6 py-8 bg-brand-cream sm:border-[3px] border-brand-teal-light sm:rounded-[2rem]">
            <component :is="modal"></component>
            <component :is="card"></component>
        </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        computed: {
            ...mapGetters([
                'card',
                'modal',
            ])
        }
    }
</script>
